import { render, staticRenderFns } from "./BldMenu.vue?vue&type=template&id=2052b69c&scoped=true&"
import script from "./BldMenu.vue?vue&type=script&lang=js&"
export * from "./BldMenu.vue?vue&type=script&lang=js&"
import style0 from "./BldMenu.vue?vue&type=style&index=0&id=2052b69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052b69c",
  null
  
)

export default component.exports